import React, { useEffect } from "react";
import { PostInterface } from "src/store/community/postsSlice";
import { selectCategoryEntities, selectCategoryIds } from "src/store/community/categoriesSlice";

import { Button, Form, Input, InputNumber, Radio, Select, DatePicker } from "antd";
import FileDropzone from "src/componets/FileDropzone";
import { EntityId } from "@reduxjs/toolkit";
import { filterOption } from "src/helpers/FormHelper";
import { useAppSelector } from "src/store/hooks";
import { DollarOutlined } from "@ant-design/icons";

interface propsInterface {
  params?: PostInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const categories = useAppSelector(selectCategoryEntities);
  const categoryIds = useAppSelector(selectCategoryIds);
  const [form] = Form.useForm();
  const dateConfig = {
    rules: [{ required: true, message: 'Please select time!' }],
  };

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const renderCategoryOption = (id: EntityId) => {
    const item = categories[id];

    if (!item) {
      return null;
    }

    return <Select.Option key={id} value={id} title={item.name}>{item.name}</Select.Option>
  }

  const renderCategories = () => {
    return (
      <Form.Item
        name='category_id'
        label="Select a category"
      >
        <Select
          allowClear
          showSearch
          filterOption={filterOption}
          placeholder='Select a category'
        >
          {categories && categoryIds.map(renderCategoryOption)}
        </Select>
      </Form.Item>
    )
  }

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='target' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <div className='v-group-dropzone'>
        <FileDropzone name='thumbnail' label='Thumbnail' preview={params?.thumbnail_url} />
        <FileDropzone name='file' label='File' preview={params?.file_url} />
      </div>

      <Form.Item name='app_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      {renderCategories()}

      <Form.Item name='title' label="Title">
        <Input placeholder='Title' />
      </Form.Item>

      <Form.Item name="moment_date" label='Published_at' {...dateConfig}>
        <DatePicker showTime />
      </Form.Item>

      <Form.Item
        label="Purchase by"
        tooltip='When ads selected, user can purchase post by watching ads or paying coins'
        name='purchase_type'
      >
        <Radio.Group>
          <Radio.Button value="free">free</Radio.Button>
          <Radio.Button value='coins'>coins</Radio.Button>
          <Radio.Button value='ads'>ads</Radio.Button>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        name='coins'
        label='Cost'
        className='v-mb-30'
      >
        <InputNumber
          min={0}
          step={5}
          placeholder='5'
          prefix={<DollarOutlined />}
        />
      </Form.Item>

      <Form.Item name='description' label="Description">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item name='search_text' label="Search Text">
        <Input.TextArea rows={3} />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
